import Swiper, { EffectFade, Navigation, Pagination, Autoplay } from 'swiper'
import { onCustomProps, onNavigationEl } from './swiper/helpers'
import { onSelect, onSelectAll } from './utils/dom'

const GENERAL_PROPS = {
  grabCursor: true,
  loop: true,
  speed: 3000,
}

onSelectAll('[data-js-swiper="tabs-clients"]').forEach((slider) => {
  new Swiper(slider, {
    modules: [Autoplay],
    ...GENERAL_PROPS,
    slidesPerView: 'auto',
    centeredSlides: true,
    autoplay: {
      delay: 200,
      pauseOnMouseEnter: false,
    },
    breakpoints: {
      770: { slidesPerView: 4, spaceBetween: 44, centeredSlides: false },
      980: { slidesPerView: 5, spaceBetween: 52, centeredSlides: false },
      1140: { slidesPerView: 6, spaceBetween: 70, centeredSlides: false },
    },
    on: {
      init: function (instSwiper) {
        instSwiper.customProps = { ...onCustomProps(instSwiper) }
      },
    },
  })
})

onSelectAll('[data-js-swiper="reviews"]').forEach((slider) => {
  const { nextEl, prevEl } = onNavigationEl(null, slider)
  new Swiper(slider, {
    modules: [EffectFade, Pagination, Navigation,Autoplay],
    ...GENERAL_PROPS,
    speed: 400,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3400
    },
    navigation: {
      nextEl,
      prevEl,
    },
    pagination: {
      el: '.bl-reviews-progress-bar',
      type: 'progressbar',
    },
    
    on: {
      init: function (instSwiper) {
        instSwiper.customProps = { ...onCustomProps(instSwiper) }
      },
    },
  })
})

onSelectAll('[data-js-swiper="insets-gallery"]').forEach((slider) => {
  const { nextEl, prevEl } = onNavigationEl(null, slider)
  new Swiper(slider, {
    modules: [EffectFade, Autoplay],
    ...GENERAL_PROPS,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl,
      prevEl,
    },
    autoplay: {
      delay: 5000,
    },
    on: {
      init: function (instSwiper) {
        instSwiper.customProps = { ...onCustomProps(instSwiper) }
      },
    },
  })
})

onSelectAll('[data-js-swiper="filter"]').forEach((nodeSlider) => {
  const { nextEl, prevEl } = onNavigationEl(null, nodeSlider)

  const SWIPER_FILTER = new Swiper(nodeSlider, {
    modules: [Navigation],
    ...GENERAL_PROPS,
    speed: 1000,
    navigation: {
      nextEl,
      prevEl,
    },
    on: {
      init: function (instSwiper) {
        instSwiper.customProps = { ...onCustomProps(instSwiper) }
      },
      slideChange: function (instSwiper) {
        let currentSldier = instSwiper.slides[instSwiper.activeIndex]
        let currentTab = onSelect(`[data-js-fil-target]`, currentSldier)

        setTimeout(() => {
          if (currentTab !== null) currentTab.click()
        }, 800)
      },
    },
  })
})
